import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import moment from "moment";
// Services
import { getPreparations } from "@/services/index";
// Components
import { Overlay, Snackbar, PreparationFilterBar } from "@/components/index";
// Entities
import {
  Warehouse,
  Preparation,
  PreparationsFields,
  Company,
} from "@/entities/index";

@Component({
  components: {
    PreparationFilterBar,
    Overlay,
    Snackbar,
  },
})
export default class OrderPreparation extends Vue {
  ordersPreparation: Preparation[] = [];
  ordersPreparationCSV: Preparation[] = [];
  warehouses: Warehouse[] = [];

  client = this.company.codeLogistic;
  idCompany = this.company.id;

  preparationsFields: PreparationsFields = {
    reference: "",
    recipientReference: "",
    clientNumber: "",
    status: "",
    warehouse: "",
    shippingDateBegin: "",
    shippingDateEnd: "",
    receptionDateBegin: "",
    receptionDateEnd: "",
  };

  snackbarNoField = false;
  overlay = false;

  headers = [
    {
      text: this.$t("Preparation.table.reference"),
      class: "indigo--text text--darken-4",
      align: "start",
      value: "reference",
    },
    {
      text: this.$t("Preparation.table.recipientReference"),
      class: "indigo--text text--darken-4",
      value: "recipientReference",
    },
    {
      text: this.$t("Preparation.table.clientNumber"),
      class: "indigo--text text--darken-4",
      value: "client.clientNumber",
    },
    {
      text: this.$t("Preparation.table.client"),
      class: "indigo--text text--darken-4",
      value: "client.client",
    },
    {
      text: this.$t("Preparation.table.clientPostalCode"),
      class: "indigo--text text--darken-4",
      value: "client.clientPostalCode",
    },
    {
      text: this.$t("Preparation.table.clientCity"),
      class: "indigo--text text--darken-4",
      value: "client.clientCity",
    },
    {
      text: this.$t("Preparation.table.clientCountry"),
      class: "indigo--text text--darken-4",
      value: "client.clientCountry",
    },
    {
      text: this.$t("Preparation.table.status"),
      class: "indigo--text text--darken-4",
      value: "status",
    },
    {
      text: this.$t("Preparation.table.warehouse"),
      class: "indigo--text text--darken-4",
      value: "warehouse",
    },
    {
      text: this.$t("Preparation.table.tourCode"),
      class: "indigo--text text--darken-4",
      value: "tourCode",
    },
    {
      text: this.$t("Preparation.table.family"),
      class: "indigo--text text--darken-4",
      value: "client.clientFamilly",
    },
    {
      text: this.$t("Preparation.table.subfamily"),
      class: "indigo--text text--darken-4",
      value: "client.clientSubFamilly",
    },
    {
      text: this.$t("Preparation.table.shippingDate"),
      class: "indigo--text text--darken-4",
      value: "shippingDate",
    },
    {
      text: this.$t("Preparation.table.receptionDate"),
      class: "indigo--text text--darken-4",
      value: "receptionDate",
    },
    {
      text: this.$t("Preparation.table.orderDetails"),
      class: "indigo--text text--darken-4",
      value: "orderDetail",
      sortable: false,
    },
  ];

  headersCSV = [
    {
      text: "Reference",
      value: "reference",
    },
    {
      text: "Commande destinataire",
      value: "recipientReference",
    },
    {
      text: "Numero client",
      value: "client.clientNumber",
    },
    { text: "Nom client", value: "client.client" },
    {
      text: "Code postal",
      value: "client.clientPostalCode",
    },
    {
      text: "Ville",
      value: "client.clientCity",
    },
    {
      text: "Pays",
      value: "client.clientCountry",
    },
    { text: "Statut", value: "status" },
    { text: "Entrepot", value: "warehouse" },
    { text: "Code tournee", value: "tourCode" },
    { text: "Famille", value: "client.clientFamilly" },
    { text: "Sous-famille", value: "client.clientSubFamilly" },
    { text: "Date d'expedition", value: "shippingDate" },
    {
      text: "Date de reception",
      value: "receptionDate",
    },
  ];

  async loadPreparations(): Promise<void> {
    if (this.checkFields() === false) {
      const showOverlay = this.$refs.overlay as Overlay;
      showOverlay.show();
      this.ordersPreparation = await getPreparations({
        client: this.client,
        userId: this.profile.id,
        preparationsFields: {
          reference:
            this.preparationsFields.reference === ""
              ? undefined
              : this.preparationsFields.reference,
          recipientReference:
            this.preparationsFields.recipientReference === ""
              ? undefined
              : this.preparationsFields.recipientReference,
          clientNumber:
            this.preparationsFields.clientNumber === ""
              ? undefined
              : this.preparationsFields.clientNumber,
          status:
            this.preparationsFields.status === ""
              ? undefined
              : this.preparationsFields.status,
          warehouse:
            this.preparationsFields.warehouse === ""
              ? undefined
              : this.preparationsFields.warehouse,
          shippingDateBegin:
            this.preparationsFields.shippingDateBegin === ""
              ? undefined
              : this.preparationsFields.shippingDateBegin,
          shippingDateEnd:
            this.preparationsFields.shippingDateEnd === ""
              ? undefined
              : this.preparationsFields.shippingDateEnd,
          receptionDateBegin:
            this.preparationsFields.receptionDateBegin === ""
              ? undefined
              : this.preparationsFields.receptionDateBegin,
          receptionDateEnd:
            this.preparationsFields.receptionDateEnd === ""
              ? undefined
              : this.preparationsFields.receptionDateEnd,
        },
      });
      showOverlay.hide();
    }
  }

  async search(preparationsFields: PreparationsFields): Promise<void> {
    this.preparationsFields = preparationsFields;
    await this.loadPreparations();
    this.ordersPreparation.forEach((order) => {
      order.shippingDate = moment(order.shippingDate).format("DD/MM/YYYY");
      order.receptionDate = moment(order.receptionDate).format("DD/MM/YYYY");
    });
  }

  async allWarehouses(): Promise<void> {
    this.warehouses = (
      await axios.get(`/api/warehouses/company/${this.idCompany}`)
    ).data as Warehouse[];
  }

  mounted(): void {
    this.allWarehouses();
  }

  goToOrderDetail(item: Preparation): void {
    this.$router.push({
      name: "Détail de la commande",
      params: {
        reference: item.reference,
      },
    });
  }

  // ========== GETTERS ========== //

  get company(): Company {
    return this.$store.getters.company;
  }

  get profile() {
    return this.$store.getters.profile;
  }

  // ========== OTHERS METHODS ========== //

  checkFields(): boolean {
    if (
      [
        this.preparationsFields.reference,
        this.preparationsFields.recipientReference,
        this.preparationsFields.clientNumber,
        this.preparationsFields.status,
        this.preparationsFields.warehouse,
        this.preparationsFields.shippingDateBegin,
        this.preparationsFields.shippingDateEnd,
        this.preparationsFields.receptionDateBegin,
        this.preparationsFields.receptionDateEnd,
      ].filter((x) => x != "").length >= 1
    ) {
      return false;
    }
    this.showSnackbar();
    return true;
  }

  clear(): void {
    this.preparationsFields = {
      reference: "",
      recipientReference: "",
      clientNumber: "",
      status: "",
      warehouse: "",
      shippingDateBegin: "",
      shippingDateEnd: "",
      receptionDateBegin: "",
      receptionDateEnd: "",
    };
  }

  colorRow(item: Preparation): any {
    const position = this.ordersPreparation.indexOf(item, 0);
    if (position % 2 == 0) {
      return "light-green lighten-5";
    }
  }

  goToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  showSnackbar(): void {
    const snackbar = this.$refs.snackbar as Snackbar;
    snackbar.show();
  }

  // === EXPORT TO CSV === //

  async getOrdersPreparationCSV(): Promise<Preparation[]> {
    await this.loadPreparations();
    const ordersCSV = this.ordersPreparation;
    const userId = this.profile.id;
    await axios.post("/api/stats/action", {
      userId,
      action: "Extraction CSV des préparations de commandes",
    });
    return ordersCSV;
  }

  convertToCSV(json: any): string {
    if (json.reference === null || json.reference === undefined) {
      json.reference = "";
    }
    if (
      json.recipientReference === null ||
      json.recipientReference === undefined
    ) {
      json.recipientReference = "";
    }
    if (
      json.client.clientNumber === null ||
      json.client.clientNumber === undefined
    ) {
      json.client.clientNumber = "";
    }
    if (json.client.client === null || json.client.client === undefined) {
      json.client.client = "";
    }
    if (
      json.client.clientPostalCode === null ||
      json.client.clientPostalCode === undefined
    ) {
      json.client.clientPostalCode = "";
    }
    if (
      json.client.clientCity === null ||
      json.client.clientCity === undefined
    ) {
      json.client.clientCity = "";
    }
    if (
      json.client.clientCountry === null ||
      json.client.clientCountry === undefined
    ) {
      json.client.clientCountry = "";
    }
    if (json.status === null || json.status === undefined) {
      json.status = "";
    }
    if (json.warehouse === null || json.warehouse === undefined) {
      json.warehouse = "";
    }
    if (json.tourCode === null || json.tourCode === undefined) {
      json.tourCode = "";
    }
    if (json.clientFamilly === null || json.clientFamilly === undefined) {
      json.clientFamilly = "";
    }
    if (json.clientSubFamilly === null || json.clientSubFamilly === undefined) {
      json.clientSubFamilly = "";
    }
    if (json.shippingDate === null || json.shippingDate === undefined) {
      json.shippingDate = "";
    }
    if (json.receptionDate === null || json.receptionDate === undefined) {
      json.receptionDate = "";
    }
    return `"${json.reference}";"${json.recipientReference}";"${json.client.clientNumber}";"${json.client.client}";"${json.client.clientPostalCode}";"${json.client.clientCity}";"${json.client.clientCountry}";"${json.status}";"${json.warehouse}";"${json.tourCode}";"${json.clientFamilly}";"${json.clientSubFamilly}";"${json.shippingDate}";"${json.receptionDate}"`;
  }

  downloadCSV(): void {
    const orders = this.getOrdersPreparationCSV();
    const csvJSON = this.ordersPreparation.map((json: any) =>
      this.convertToCSV(json)
    );
    csvJSON.unshift(
      this.headersCSV.map((header: any) => header.text).join(";")
    );
    const csvData = csvJSON.join("\n");
    const csvBlob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
    const csvUrl = URL.createObjectURL(csvBlob);
    const link = document.createElement("a");
    link.href = csvUrl;
    link.download = "Preparations des commandes.csv";
    link.click();
  }
}
